import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-campaign-details',
    templateUrl: './campaign-details.component.html',
    styleUrls: ['./campaign-details.component.scss'],
    standalone: false
})
export class CampaignDetailsComponent implements OnInit {

  @Input() campaign;

  constructor(public dialogRef: MatDialogRef<CampaignDetailsComponent>) { }

  ngOnInit(): void {
  }

  close(): void {
    this.dialogRef.close();
  }
}
